import React, { useMemo } from 'react';

import { CinemaBlogDto } from '@cineamo/api/models/cinema-blog/CinemaBlogDto.types';

import { cn } from '@cineamo/ui/src/helpers/cn';
import { getBlogPostUrl } from '@cineamo/ui/src/helpers/url-helper';

import { Link } from '@/i18n/routing';

const CinemaBlogTitleItem: React.FC<{
    cinemaBlog: CinemaBlogDto;
    isSelected?: boolean;
    onClick?: () => void;
}> = ({ cinemaBlog, isSelected, onClick }) => {
    const blogId = useMemo(() => getBlogPostUrl(cinemaBlog), [cinemaBlog]);
    return (
        <Link
            href={`#${blogId}`}
            className={cn(
                'px-[9px] lg:px-0 py-[8px] border-b-1 border-[rgba(var(--on-background-color-rgb),0.2)]',
                'cursor-pointer hover:bg-[var(--surface-color)] duration-150',
                isSelected ? 'text-body-bold-14' : 'text-body-14'
            )}
            onClick={() => onClick && onClick()}>
            {cinemaBlog.title}
        </Link>
    );
};

export default CinemaBlogTitleItem;
